import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from '../services/rest.service';


@Injectable()
export class CountryCityService {

  constructor(private restHttp: RestService) { }

  public getAllCountries(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Country`);
  }

  public createCountry(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Country`, model);
 }

 getCountrybyId(id): Observable<any> {
  return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CountryGetById/${id}`);
}
public UpdateCountry(model) {
  return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateCountrys`, model);
}

public DeleteCountry(id) {
  return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteCountry?countryId=${id}`);
}

public getAllCities(id): Observable<any> {
  return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CityById?countryId=${id}`);
}

uploadImage(formData) {
  return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/City/MediaUpload`, formData);
}

addCity(model) {
  return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/City`, model);
}

getCityById(id): Observable<any> {
  return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CityById/${id}`);
}
public UpdateCity(model) {
  return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateCity`, model);
}
}
